class MainSearch extends SearchForm {
  constructor() {
    super();
    this.allSearchInputs = Array.from(document.querySelectorAll(
      'main-search input[type="search"][name="q"], search-form input[type="search"][name="q"], predictive-search input[type="search"][name="q"]'
    )).filter(input => input.form);
    this.setupEventListeners();
  }

  setupEventListeners() {
    let allSearchForms = [];
    this.allSearchInputs.forEach((input) => allSearchForms.push(input.form));
    this.input.addEventListener('focus', this.onInputFocus.bind(this));
    if (allSearchForms.length < 2) return;
    allSearchForms.forEach((form) => form.addEventListener('reset', this.onFormReset.bind(this)));
    this.allSearchInputs.forEach((input) => input.addEventListener('input', this.onInput.bind(this)));
  }

  onFormReset(event) {
    if (event.target === this.input.form) super.onFormReset(event);
    if (super.shouldResetForm()) {
      this.keepInSync('', event.target.querySelector('input[type="search"]'));
    }
  }

  onInput(event) {
    const target = event.target;
    this.keepInSync(target.value, target);
  }

  onInputFocus() {
    const isSmallScreen = window.innerWidth < 750;
    if (isSmallScreen) {
      this.scrollIntoView({ behavior: 'smooth' });
    }
  }

  keepInSync(value, target) {
    this.allSearchInputs.forEach((input) => {
      if (input !== target) {
        input.value = value;
        input.closest('main-search, search-form, predictive-search')?.toggleResetButton();
      }
    });
  }
}

customElements.define('main-search', MainSearch);
